<section class="services-card">
  <h3 class="services-card__label">
    <ion-icon name="create-outline"></ion-icon>
    {{ "UX_TEXT.DEMANDE.DESCRIPTION.TITLE" | translate }}
    <span class="services-card__label-opt">({{ "UX_TEXT.DEMANDE.DESCRIPTION.OPT_VOICE" | translate }})</span>
  </h3>
  <textarea
    class="desc-textarea"
    [value]="description"
    (focus)="inputFocus.emit()"
    (blur)="inputBlur.emit()"
    (input)="valueChange.emit(($any($event.target).value || '').toString())"
    maxlength="254"
    [placeholder]="placeholder"
  ></textarea>
  <div class="desc-footer">
    <span class="desc-hint">
      <ion-icon name="bulb-outline"></ion-icon>
      {{ "UX_TEXT.DEMANDE.DESCRIPTION.HINT" | translate }}
    </span>
    <span class="desc-count" [class.desc-count--warn]="descriptionLength >= 240">
      {{ descriptionLength }} / 254
    </span>
  </div>
</section>
